import { all, put, call, takeEvery } from 'redux-saga/effects';
import { LOAD_OPERATIONS } from './types';
import { setOperationsAction } from './actions';
import { errorAlert } from '../../Common/alerts';
import { OperationsGraphQL } from './graphql';

function* operationList(data) {
  const { payload } = data;

  try {
    const { operations } = yield call(OperationsGraphQL, payload);
    yield put(setOperationsAction(operations));
  } catch(error) {
    errorAlert("Ops...", error);
  }
}

function* watchOperationList() {
  yield takeEvery(LOAD_OPERATIONS, operationList);
}

export default function* rootSaga() {
  yield all([watchOperationList()]);
}


// WEBPACK FOOTER //
// ./src/ZWallet/Operations/sagas.js